import isObject from 'lodash-es/isObject';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { Title } from './title';
import { GenerateItem } from './generate-item';
const factory = create({ theme }).properties();
export const Generator = factory(({ properties }) => {
    const { key: basekey, widgetType = null, skipTitle, insection = false, intable = false, renderBody = false, compconn, additionalClasses } = properties();
    let { topic } = properties();
    if (topic.topic) {
        topic = topic.topic;
    }
    const attributes = topic.attributes;
    const children = topic.children;
    const kids = [];
    if (!children) {
        if (insection || intable) {
            return kids;
        }
        const xqa = basekey && `generator ${basekey}`;
        return v('div', { key: basekey, xqa }, kids);
    }
    const shortdescIndex = children.findIndex((value) => {
        return isObject(value) && 'shortdesc' in value;
    });
    if (!skipTitle && !insection) {
        kids.push(w(Title, { title: children[0], widgetType, insection }));
    }
    if (!renderBody && shortdescIndex >= 0) {
        const item = children[shortdescIndex];
        kids.push(w(GenerateItem, { item, compconn, additionalClasses }));
    }
    else {
        const bodyAt = children.findIndex((value) => {
            return isObject(value) && 'body' in value;
        });
        if (bodyAt > -1) {
            const bodykids = children[bodyAt].body.children;
            bodykids.forEach((val) => {
                kids.push(w(GenerateItem, { item: val, compconn, additionalClasses }));
            });
        }
        else if (insection) {
            const sectionkids = children;
            sectionkids.forEach((val) => {
                kids.push(w(GenerateItem, { item: val, compconn, additionalClasses }));
            });
        }
        else if (intable) {
            const tablekids = children;
            tablekids.forEach((val) => {
                kids.push(w(GenerateItem, { item: val, compconn, additionalClasses }));
            });
        }
        else {
            const idx = Math.min(children.length - 1, 1);
            kids.push(w(GenerateItem, { item: children[idx], compconn, additionalClasses }));
        }
    }
    const { id: idval } = attributes || {};
    if (insection || intable) {
        return kids;
    }
    const key = basekey || idval;
    const xqa = key && `generator ${key}`;
    return v('div', { key, xqa }, kids);
});
